import { Directive } from '@vbrick/angular-ts-decorators';

@Directive({
	selector: '[option-row]',
	template: `
		<div
			class="insight-option-row"
			ng-include="$ctrl.optionTemplateUrl || 'option-row.html'"
		></div>
	`
})
export class OptionRowDirective {

}
